export const NOW_PLACEHOLDER = '__hs__NOW';
export const TODAY_DATE_PLACEHOLDER = '__hs__TODAY_DATE';
export const TOMORROW_DATE_PLACEHOLDER = '__hs__TOMORROW_DATE';
export const ALL_DATE_PLACEHOLDERS = [NOW_PLACEHOLDER, TODAY_DATE_PLACEHOLDER, TOMORROW_DATE_PLACEHOLDER];
export const TWO_MINUTES_IN_MILLIS = 120000;